<template>
  <div>
    <!--    <vue-element-loading :active="status === 'loading'" />-->

    <v-card>
      <v-card-title style="display: flex; justify-content: space-between">
        <div>
          <v-icon color="primary"> mdi-bus-side </v-icon>
          <span class="pl-2">{{ $t('pages.current_ride') }}</span>
        </div>
        <v-btn
          color="error"
          type="button"
          :loading="status === 'loading-stop'"
          @click="stopRide()"
        >
          {{ $t('actions.stop') }}
        </v-btn>
      </v-card-title>

      <v-card-text>Students</v-card-text>
      <v-card-text v-if="activeRide">
        <div>
          {{ $t('table.total') }}:
          <span v-if="activeRide.bus">
            {{ activeRide.bus.students_count }}
          </span>
          <span v-else>-</span>
          <!--      </v-card-text>-->
          <!--      <v-card-text v-if="activeRide">-->
          / {{ $t('table.taken') }}:
          {{ activeRide.taken_ride_students_count }}
          / {{ $t('table.dropped') }}:
          {{ activeRide.dropped_ride_students_count }}
          / {{ $t('table.rejected') }}:
          {{ activeRide.rejected_ride_students_count }}
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 10px;
          "
        >
          <v-btn
            type="button"
            color="primary"
            dense
            small
            @click="changeOrder"
            :loading="status === 'loading-change-order'"
          >
            {{ $t('actions.change_order') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <div class="rides my-4">
      <v-card class="col-md-4" v-for="student in students" :key="student.id">
        <!--          style="margin-inline: 15px; margin-bottom: 15px"-->
        <!--          max-width="400"-->
        <v-card-title class="pb-0"> {{ student.name }} </v-card-title>

        <v-card-text class="text--primary">
          <div>
            {{ $t('table.address') }}:&nbsp;
            <span v-if="student.address">
              {{ student.address }}
            </span>
            <span v-else>-</span>
          </div>
          <div>
            {{ $t('table.taken_at') }}:&nbsp;
            <span v-if="student.started_at">
              {{ student.started_at | moment('DD/MM/YYYY') }} -
              {{ student.started_at | moment('HH:mm') }}
            </span>
            <span v-else>-</span>
          </div>
          <div>
            {{ $t('table.dropped_at') }}:&nbsp;
            <span v-if="student.finished_at">
              {{ student.finished_at | moment('DD/MM/YYYY') }} -
              {{ student.finished_at | moment('HH:mm') }}
            </span>
            <span v-else>-</span>
          </div>
          <div v-if="student.rejected_at">
            {{ $t('table.absent_at') }}:&nbsp;
            <span v-if="student.rejected_at">
              {{ student.rejected_at | moment('DD/MM/YYYY') }} -
              {{ student.rejected_at | moment('HH:mm') }}
            </span>
            <span v-else>-</span>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-if="
              !student.started_at &&
              !student.finished_at &&
              !student.rejected_at
            "
            color="success"
            type="button"
            :loading="status === 'loading-take-' + student.id"
            @click="takeStudent(student.id)"
          >
            {{ $t('actions.pick_up') }}
          </v-btn>

          <v-btn
            v-if="
              student.started_at && !student.finished_at && !student.rejected_at
            "
            color="error"
            type="button"
            :loading="status === 'loading-drop-' + student.id"
            @click="dropStudent(student.id)"
          >
            {{ $t('actions.drop_off') }}
          </v-btn>

          <v-btn
            v-if="
              !student.started_at &&
              !student.finished_at &&
              !student.rejected_at
            "
            color="error"
            type="button"
            :loading="status === 'loading-reject-' + student.id"
            @click="rejectStudent(student.id)"
          >
            {{ $t('actions.absent') }}
          </v-btn>

          <v-btn
            v-if="student.finished_at"
            color="success"
            type="button"
            disabled
          >
            {{ $t('actions.finished') }}
          </v-btn>

          <v-btn
            v-if="student.rejected_at"
            color="error"
            type="button"
            disabled
          >
            {{ $t('actions.absent') }}
          </v-btn>

          <v-btn
            v-if="student.rejected_at"
            color="primary"
            type="button"
            :loading="status === 'loading-retake-' + student.id"
            @click="retakeStudent(student.id)"
          >
            {{ $t('actions.retry_pick_up') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div class="mx-2">
      <v-btn
        v-if="activeRide"
        width="100%"
        color="error"
        type="button"
        :loading="status === 'loading-drop-all-students'"
        @click="dropAllStudents()"
        :disabled="
          activeRide.bus.students_count ===
            activeRide.taken_ride_students_count +
              activeRide.dropped_ride_students_count +
              activeRide.rejected_ride_students_count &&
          activeRide.taken_ride_students_count == 0
        "
      >
        {{ $t('actions.drop_off_all') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';

export default {
  components: {
    VueElementLoading,
  },
  data() {
    return {
      status: '',
      activeRide: null,
      students: [],
      direction: 'ASC',
    };
  },
  mounted() {
    this.getStartedRide();
    // this.getLocation();
    this.initCheckStopRide();
  },
  methods: {
    getStartedRide() {
      this.status = 'loading';
      axios
        .get(`/rides/started`)
        .then((response) => {
          if (!response?.data) {
            this.$router.push({ name: 'driver-rides' });
            return;
          }
          this.activeRide = response?.data;
          if (this.activeRide?.finished_at) {
            this.$router.push({ name: 'driver-rides' });
            return;
          }
          // this.getLocation();
          this.getBusStudents(this.activeRide?.bus_id);
        })
        .catch(() => {
          this.activeRide = null;
          this.$notify({
            title: 'Error',
            text: 'Error while retrieving started ride',
            type: 'error',
          });
          this.$router.push({ name: 'driver-rides' });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    getBusStudents(bus_id) {
      axios
        .get(`/buses/${bus_id}/students`, {
          params: { direction: this.direction },
        })
        .then((response) => {
          this.students = response?.data;
          this.students = this.students.map(function (student) {
            const rideStudent = this.activeRide.ride_students.find(
              (item) => item.student_id === student.id
            );
            if (rideStudent) {
              student['started_at'] = rideStudent.started_at;
            }
            if (rideStudent) {
              student['finished_at'] = rideStudent.finished_at;
            }
            if (rideStudent) {
              student['rejected_at'] = rideStudent.rejected_at;
            }
            return student;
          }, this);
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while retrieving students',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    stopRide() {
      const totalStudents = this.activeRide.bus.students_count;
      const finishedStudents =
        this.activeRide.dropped_ride_students_count +
        this.activeRide.rejected_ride_students_count;

      if (totalStudents != finishedStudents) {
        this.$notify({
          title: 'Error',
          text: 'You need to drop all students',
          type: 'error',
        });
        return;
      }
      this.status = 'loading-stop';
      axios
        .post(`/rides/${this.activeRide.id}/finish`)
        .then(() => {
          // this.startedRide = response?.data;
          this.$notify({
            title: 'Success',
            text: 'Success stopped ride',
            type: 'success',
          });
          // this.$swal('Success', 'Success stopped ride', 'success');
          this.$router.push({ name: 'driver-rides' });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while stopping ride',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    takeStudent(student_id) {
      this.status = 'loading-take-' + student_id;
      axios
        .post(`/rides/${this.activeRide.id}/take-student`, { student_id })
        .then(() => {
          this.getStartedRide();
          this.$notify({
            title: 'Success',
            text: 'Student toked',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while taking student',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    dropStudent(student_id) {
      this.status = 'loading-drop-' + student_id;
      axios
        .post(`/rides/${this.activeRide.id}/drop-student`, { student_id })
        .then(() => {
          this.getStartedRide();
          this.$notify({
            title: 'Success',
            text: 'Student dropped',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while dropping student',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    rejectStudent(student_id) {
      this.status = 'loading-reject-' + student_id;
      axios
        .post(`/rides/${this.activeRide.id}/reject-student`, { student_id })
        .then(() => {
          this.getStartedRide();
          this.$notify({
            title: 'Success',
            text: 'Student rejected',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while rejecting student',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    retakeStudent(student_id) {
      this.status = 'loading-retake-' + student_id;
      axios
        .post(`/rides/${this.activeRide.id}/retake-student`, { student_id })
        .then(() => {
          this.getStartedRide();
          this.$notify({
            title: 'Success',
            text: 'Student teked',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while retaking student',
            type: 'error',
          });
        })
        .then(() => {
          this.status = '';
        });
    },
    dropAllStudents() {
      const takenStudents = this.students.filter(
        (student) => !!student.started_at && !student.finished_at
      )?.length;
      const rejectedStudents = this.students.filter(
        (student) => !!student.rejected_at
      )?.length;
      const finishedStudents = this.students.filter(
        (student) => !!student.finished_at
      )?.length;
      if (
        this.activeRide?.bus?.students_count !==
          takenStudents + rejectedStudents + finishedStudents &&
        takenStudents === 0
      ) {
        this.$notify({
          title: 'Error',
          text: 'There are any students taken',
          type: 'error',
        });
      }

      let students = this.students.filter(
        (student) =>
          !!student.started_at && !student.finished_at && !student.rejected_at
      );
      students = students.map(({ id }) => id);

      if (students.length === 0) {
        return;
      }

      this.status = 'loading-drop-all-students';
      axios
        .post(`/rides/${this.activeRide.id}/drop-all-students`, {
          student_ids: students,
        })
        .then(() => {
          this.getStartedRide();
          this.$notify({
            title: 'Success',
            text: 'You dropped ' + students.length + ' students.',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while dropping all students',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    getLocation() {
      if ('geolocation' in navigator) {
        navigator.geolocation.watchPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            this.shareLocation({ latitude, longitude });
            console.log('Real-time location:', latitude, longitude);
          },
          (error) => {
            console.error('Error getting location:', error.message);
            switch (error.code) {
              case error.PERMISSION_DENIED:
                console.log('User denied the request for Geolocation.');
                break;
              case error.POSITION_UNAVAILABLE:
                console.log('Location information is unavailable.');
                break;
              case error.TIMEOUT:
                console.log('The request to get user location timed out.');
                break;
              default:
                console.log('An unknown error occurred.');
            }
          },
          {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 5000,
          }
        );
        navigator.wakeLock.request('screen');
      } else {
        console.log('Geolocation not supported in this browser.');
      }
    },
    shareLocation(data) {
      if (!this.activeRide) {
        return;
      }

      axios
        .post(`/rides/${this.activeRide.id}/location`, data)
        .then(() => {})
        .catch(() => {
          // this.$notify({
          //   title: 'Error',
          //   text: 'Error while dropping all students',
          //   type: 'error',
          // });
        })
        .then(() => {});
    },
    initCheckStopRide() {
      window.Echo.private(`bus-ride-stop`).listen('.ride-stop', (e) => {
        // this.getAllRides(this.bus_id);
        this.activeRide = e?.ride;
        console.log(e);
      });
    },
    changeOrder() {
      this.direction = this.direction === 'ASC' ? 'DESC' : 'ASC';
      this.status = 'loading-change-order';
      this.getBusStudents(this.activeRide?.bus_id);
    },
  },
  watch: {
    'activeRide.finished_at': function (val) {
      if (val) {
        this.$notify({
          title: 'Stoped',
          text: 'This ride is stoped by school',
          type: 'error',
        });
        this.$router.push({ name: 'driver-rides' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rides {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

@media (max-width: 850px) {
  .rides {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .rides {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
